document.addEventListener("DOMContentLoaded", function () {
  // Get the service dropdown and VDI dropdown elements
  var serviceDropdown = document.querySelector(
    'select[data-option-name="carrier-monthly-service-fee-and-processing-rate"]'
  );
  var vdiDropdown = document.querySelector("#do-you-want-vdi-set-up");

  if (serviceDropdown && vdiDropdown) {
    // Initial check
    var selectedOption = serviceDropdown.value;
    if (selectedOption.includes("Cashless Plus")) {
      // Set VDI to "Yes" and remove "No" option
      vdiDropdown.value = "Yes";
      $("#do-you-want-vdi-set-up option[value='No']").hide();
      $("#vdi-setup").attr("value", "");
      $("#vdi-setup").attr("name", "properties[VDI Setup]");
    }

    // On change event
    serviceDropdown.addEventListener("change", function () {
      var selectedOption = serviceDropdown.value;
      if (selectedOption.includes("Cashless Plus")) {
        // Set VDI to "Yes" and remove "No" option
        vdiDropdown.value = "Yes";
        $("#do-you-want-vdi-set-up option[value='No']").hide();
        $("#vdi-setup").attr("value", "");
        $("#vdi-setup").attr("name", "properties[VDI Setup]");
      } else {
        // Show "No" option again and set to "No"
        $("#do-you-want-vdi-set-up option[value='No']").show();
        vdiDropdown.value = "No";
        $("#vdi-setup").removeAttr("name");
      }
    });
  }

  // Logic for Existing Customer Dropdown
  var existingCustomerSelect = document.querySelectorAll('select[data-variant-option]');

  if (existingCustomerSelect.length > 0) {
    existingCustomerSelect.forEach(function (select) {
      var label = select.parentElement.parentElement.querySelector('label');
      if (label && label.innerText.includes('Are you an existing customer?')) {
        select.addEventListener('change', function () {
          var selectedValue = this.value;
          var messageDiv = this.parentElement.parentElement.querySelector('.existing-customer-message');

          if (messageDiv) {
            if (selectedValue === 'Yes' || selectedValue === 'YES') {
              messageDiv.style.display = 'block';
            } else {
              messageDiv.style.display = 'none';
            }
          }
        });
      }
    });
  }
});
